// react
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

// components
import { ClientReferralLeadDataPage } from '@karehero/llama/pwa/pages/ClientReferralLeadDataPage/ClientReferralLeadDataPage';

// hooks
import { useGoBack } from 'hooks/useGoBack';

// store
import { useSelector } from 'store';
import {
  LeadData,
  setLeadData,
  getLeadData,
} from 'store/slices/clientReferralSlice';
import { getAccount } from 'store/slices/iamSlice';
import { useListOrganisationLicenceCodesQuery } from 'store/api/partnerProductCodes';

// router
import { ROUTES } from 'router';

/**
 * ClientReferralLeadData wires the ClientReferralLeadDataPage to the client referral flow
 */
export const ClientReferralLeadData = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const goBack = useGoBack();
  const leadData = useSelector(getLeadData);
  const account = useSelector(getAccount);

  const { data: availableCodes } = useListOrganisationLicenceCodesQuery(
    { orgId: account?.organization?.id ?? '', available: true },
    { skip: !account?.organization?.id },
  );

  const onSubmit = useCallback(
    async (data: LeadData) => {
      dispatch(setLeadData(data));
      navigate(ROUTES.PORTAL_CLIENT_REFERRAL_REVIEW);
    },
    [dispatch, navigate],
  );

  const isSJP = account?.organization?.organizationTypeId !== 'ifa';

  return (
    <ClientReferralLeadDataPage
      onBack={goBack}
      onSubmit={onSubmit}
      initialValues={leadData || undefined}
      showLicenceCodeOption={(availableCodes?.length ?? 0) > 0}
      availableLicenceCodes={availableCodes}
      isSJP={isSJP}
    />
  );
};

export default ClientReferralLeadData;
